import { createBlankTitleTextSlide } from "@/shared/data/blank-title-text-slide";
import { createDocumentInfoElement } from "@/shared/data/document-info-element";

export const DEFAULT_FAVICON =
  "https://www.storydoc.com/assets/images/branding/favicon.png";

/** Blank first slide with the Document info pills under the paragraph (new stories only — the editor's Add slide stays plain). */
const createBlankFirstSlide = () => {
  const slide = createBlankTitleTextSlide();
  const groups = slide.children[0].children[0].children;
  const paragraphGroup = groups[groups.length - 1];
  paragraphGroup.children.push(
    createDocumentInfoElement() as unknown as (typeof paragraphGroup.children)[number],
  );
  return slide;
};

export const DEFAULT_STORY = {
  settings: {
    title: "ACME | Invest pitch deck #341",
    canonical: "0517a17a-79c1-4c71-9bb4-495b0ff4b585",
    favicon: "",
    AIClassificationType: "Pitch deck",
    engagementBarEnabled: true,
    jwtTokenIat: null,
    og: {
      siteName: "Storydoc presentation",
      locale: "en_US",
      description: "Check out my interactive Storydoc presentation",
      image: "https://www.storydoc.com/assets/images/branding/og-storydoc.gif",
    },
    fs: {
      "fs-vars": "[]",
    },
    designSystemV2: {
      font: "Roboto",
      titleColor: "#121212",
      subtitleColor: "#121212",
      paragraphColor: "#150C1D",
      hyperlinkColor: "#121212",
      highlightColor: "#121212",
      highlightTextColor: "#FFFFFF",
      primaryColor: "#1571E7",
      secondaryColor: "#EEF0F2",
      themeColor3: "#163047",
      themeColor4: "#1571E7",
      buttonRadius: "2px",
      titleFont: "Montserrat",
      subtitleFont: "Montserrat",
      paragraphFont: "Montserrat",
      backgroundColor: "#FFFFFF",
      backgroundColor2: "#F8F8F8",
      buttonColor: "#FFFFFF",
      buttonHoverColor: "#121212",
      buttonBackgroundColor: "#121212",
      buttonBackgroundHoverColor: "#EEEEEE",
      titleStyle: "700",
      titleFontSize: "40px",
      subtitleStyle: "600",
      subtitleFontSize: "24px",
      paragraphStyle: "400",
      paragraphFontSize: "18px",
      mobileTitleFontSize: "34px",
      mobileSubtitleFontSize: "24px",
      mobileParagraphFontSize: "16px",
      hyperlinkHoverColor: "#121212",
      hyperlinkUnderline: null,
      rkpiFontSize: "100%",
      titleMargin: "12px",
      subtitleMargin: "12px",
      paragraphMargin: "12px",
      theme: "Custom theme",
    },
    engagementBar: {
      presetURL:
        "https://assets.storydoc.com/8011fa118d5708e6/engagement-bar/649ef0f0488fd1000c495053.json",
      presetId: "649ef0f0488fd1000c495053",
      active: true,
    },
    gatedContent: null,
    contentPointer: "",
  },
  layoutVersion: "5.0.0",
  orgId: "",
  userId: "",
  lastUpdateUserEmail: "support@storydoc.com",
  lastUpdateUserEmailType: "private",
  status: "Draft",
  previewUrl: "",
  slides: [createBlankFirstSlide()],
};
